/**
 * Timeline Chart Constants
 * Layout and dimension constants for the timeline visualization
 * Responsive breakpoints: xs (mobile < 600px), sm (tablet < 900px), md+ (desktop ≥ 900px)
 */

// Responsive padding configurations
export const CHART_PADDING = {
  // Desktop (md and up)
  desktop: {
    top: 20,
    right: 20,
    bottom: 70,
    left: 180,
  },
  // Tablet (sm)
  tablet: {
    top: 16,
    right: 16,
    bottom: 60,
    left: 100,
  },
  // Mobile (xs)
  mobile: {
    top: 12,
    right: 12,
    bottom: 50,
    left: 60,
  },
} as const;

// Responsive row heights
export const BASE_ROW_HEIGHT = {
  desktop: 32,
  tablet: 28,
  mobile: 24,
} as const;

export const LANE_HEIGHT = {
  desktop: 28,
  tablet: 24,
  mobile: 20,
} as const;

export const LANE_SPACING = 2;
export const MIN_CHART_HEIGHT = 400;

// Responsive chart widths
export const CHART_WIDTH = {
  desktop: 800,
  tablet: 600,
  mobile: 400,
} as const;

export const MIN_BAR_WIDTH = 3;
export const CORNER_RADIUS = 4;
export const TRACKING_LINE_WIDTH = 2;
export const TRACKING_LINE_CLICKABLE_WIDTH = 20;

// Touch target minimum size (WCAG 2.1 Level AAA)
export const MIN_TOUCH_TARGET = 44;
